
import Vue from 'vue';
import Button from '@/components/Button/index.vue';
import Select from '@/components/Select/index.vue';
import { createPayment, CreatePaymentParams } from '@/services/payments/create-payments';
import { updateStatusTerritoryOfficial } from '@/services/territory/update-status-territory-oficial';
import { getTicket } from '@/services/ticket/get-ticket';
import { generateLinkGix, GenerateLinkGixParams } from '@/services/gix/generate-link-gix';

export default Vue.extend({
  components: { Button, Select },
  inject: ['getStepDate', 'formatNumber'],

  computed: {
    formatInstallments(): string[] {
      return Array.from({ length: this.getStepDate.penalty.totalInstallments }, (_, index) => {
        const current = index + 1;
        const penaltyValueInstallments = this.formatNumber(
          this.getStepDate.penalty.penaltyValue / current,
        );
        return `${current}x sem juros de ${penaltyValueInstallments}`;
      });
    },
  },
  data() {
    return {
      isLoading: false,
      isErrorHiddenMessage: true,
      userLogged: JSON.parse(sessionStorage.getItem('userLogged') as string),
      contitionBool: false,
    };
  },
  methods: {
    onHiddenMessage() {
      if (!this.getStepDate.penalty.installments) {
        this.isErrorHiddenMessage = false;
        return;
      }
      this.isErrorHiddenMessage = true;
    },
    async onNextStepSix() {
      this.$emit('moreDetails');
      this.contitionBool = true;
      try {
        this.isLoading = true;
        await this.createPaymentRequest();
        this.getTicketRequest();
        this.getGenerateGixLinkRequest();
        this.getStepDate.currentStep += 1;
        this.isLoading = false;
      } catch (err) {
        this.isLoading = false;
        this.resetStepsRegisterTerritory();
        this.getStepDate.isErrors = true;
      }
    },
    onSelectInput(_: string, index: number) {
      this.getStepDate.penalty.installments = index;
    },
    async createPaymentRequest() {
      const { stPhone } = this.userLogged;
      const { stName } = this.userLogged;
      const { stDocument } = this.userLogged;
      const params: CreatePaymentParams = {
        name: stName, // TODO add "stName"
        numInscricao: stDocument, // TODO add "stDocument"
        address: this.getStepDate.address.address,
        number: this.getStepDate.address.number,
        cep: this.getStepDate.address.zipCode.replaceAll('-', ''),
        city: this.getStepDate.address.city,
        neighboor: this.getStepDate.address.neighborhood,
        uf: this.getStepDate.address.state,
        telephone: stPhone,
        initialInstallmentToProcess: 1,
        quantityOfInstallmentsToProcess: +this.getStepDate.penalty.installments,
        totalInstallment: +this.getStepDate.penalty.installments,
        totalPenaltyDue: this.getStepDate.penalty.penaltyValue,
        cdTerritory: this.getStepDate.territory.id,
      };

      const response = await createPayment(params);
      updateStatusTerritoryOfficial(this.getStepDate.territory.id, 'PROVISORIO');
      if (response?.hasErrors) {
        this.getStepDate.isErrors = true;
      }
    },
    getTicketRequest() {
      const loader = this.$loading.show({
        container: this.$refs.loadingContainer,
      });

      getTicket(this.getStepDate.territory.id)
        .then((data) => {
          loader.hide();
          this.getStepDate.tickets = data;
          this.getStepDate.isLoadingPayment = false;
        })
        .catch(() => {
          this.resetStepsRegisterTerritory();
          this.getStepDate.isErrors = true;
        });
    },
    getGenerateGixLinkRequest() {
      const params: GenerateLinkGixParams = {
        TokenKey: this.userLogged.company.stKey,
        NameTerritory: this.getStepDate.territory.name,
        CdUser: this.userLogged.idUser,
        CdTerritory: this.getStepDate.territory.id,
        CdJourneyModel: 1,
        CdJourneyGroupModel: 1,
        CdJourneyGroupTaskModel: [1, 2, 3, 4],
      };

      generateLinkGix(params).then((data) => {
        this.getStepDate.gixUrl = data;
      });
    },
  },
});
